<div *transloco="let t">
    <td-error *ngIf="dataSource.error$ | async; let error" [message]="error.message" [title]="t('general.error')"></td-error>

    <div class="table-filter">
        <form [formGroup]="form" action="." (ngSubmit)="reload()" class="d-flex flex-column flex-sm-row justify-content-between">
            <div class="d-flex flex-grow-1 flex-sm-grow-0">
                <mat-form-field class="flex-grow-1 flex-sm-grow-0" appearance="standard" floatLabel="never">
                    <input
                        matInput
                        formControlName="filter"
                        autocapitalize="off"
                        autocomplete="off"
                        autocorrect="off"
                        type="search"
                        type="search"
                        [placeholder]="t('domain-table.filter-placeholder')"
                    />
                    <fa-icon matSuffix class="clear-button primary" icon="times" (click)="form.get('filter')!.setValue('')"></fa-icon>
                </mat-form-field>
            </div>
            <mat-button-toggle-group class="categories-button" formControlName="category" *ngIf="wallet?.address === address">
                <mat-button-toggle *ngFor="let category of categories" class="category-button" color="primary" [value]="category.name">
                    <!-- t(auction-table.filter-category-all) -->
                    <!-- t(auction-table.filter-category-won) -->
                    <!-- t(auction-table.filter-category-outbid) -->
                    {{ t('auction-table.filter-category-' + category.name) }}
                </mat-button-toggle>
            </mat-button-toggle-group>
        </form>
    </div>

    <div *ngIf="(dataSource.empty$ | async) && (hideResults | async) === false" class="empty-message p-3 w-100 text-center smooth-shadow">
        {{ t('auction-table.no-auctions') }}
    </div>

    <div class="table-container smooth-shadow d-flex" infiniteScroll (scrolled)="scrolled()" [hidden]="(dataSource.empty$ | async) || (hideResults | async)">
        <mat-table
            class="table"
            [dataSource]="dataSource"
            matSort
            (matSortChange)="reload()"
            [matSortActive]="sortField"
            [matSortDirection]="sortDirection"
            matSortDisableClear
            #sort="matSort"
        >
            <ng-container matColumnDef="name">
                <mat-header-cell *matHeaderCellDef mat-sort-header="DOMAIN_NAME">{{ t('fields.name') }}</mat-header-cell>
                <mat-cell *matCellDef="let row">
                    <div class="w-100 text-truncate">
                        <td-domain [domain]="row.domainName"></td-domain>
                    </div>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="timeLeft">
                <mat-header-cell class="col-time" *matHeaderCellDef mat-sort-header="ENDS_AT">{{ t('fields.ends') }}</mat-header-cell>
                <mat-cell class="col-time" *matCellDef="let row">
                    <span *ngIf="row.state === states.InProgress" [matTooltip]="row.endsAtUtc | dayjsDate">
                        <td-humanized-date [value]="row.endsAtUtc"></td-humanized-date>
                    </span>
                    <span *ngIf="row.state === states.CanBeSettled" [matTooltip]="row.endsAtUtc | dayjsDate">{{ t('auction-table.ended') }}</span>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="status">
                <mat-header-cell class="col-status" *matHeaderCellDef>{{ t('fields.status') }}</mat-header-cell>
                <mat-cell class="col-status" *matCellDef="let row">
                    <ng-container *ngIf="row.state === states.CanBeSettled && row.highestBid.bidder === address">
                        <td-badge color="success">{{ t('auction-table.status.won') }}</td-badge>
                        <fa-icon
                            icon="question-circle"
                            class="accent help ms-1"
                            matTooltipPosition="above"
                            [matTooltip]="t('auction-table.settle-tooltip')"
                        ></fa-icon>
                    </ng-container>
                    <td-badge *ngIf="row.state === states.InProgress && row.highestBid.bidder !== address" color="danger">
                        {{ t('auction-table.status.outbid') }}
                    </td-badge>
                    <td-badge *ngIf="row.state === states.InProgress && row.highestBid.bidder === address" color="success">
                        {{ t('auction-table.status.highestBid') }}
                    </td-badge>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="currentBid">
                <mat-header-cell class="col-amount" *matHeaderCellDef mat-sort-header="HIGHEST_BID_AMOUNT">{{ t('fields.current-bid') }}</mat-header-cell>
                <mat-cell class="col-amount" *matCellDef="let row">
                    <td-tez [value]="row.highestBid.amount"></td-tez>
                </mat-cell>
            </ng-container>
            <ng-container matColumnDef="actions">
                <mat-header-cell class="col-actions" *matHeaderCellDef></mat-header-cell>
                <mat-cell class="col-actions d-flex justify-content-end align-items-center" *matCellDef="let row">
                    <a mat-flat-button color="primary" [routerLink]="['/domain', row.domainName]">
                        <span *ngIf="row.state !== states.CanBeSettled">{{ t('actions.go-to-auction') }}</span>
                        <span *ngIf="row.state === states.CanBeSettled">{{ t('actions.settle') }}</span>
                    </a>
                </mat-cell>
            </ng-container>
            <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
            <mat-row *matRowDef="let row; columns: columns"></mat-row>
        </mat-table>
    </div>
    <div *ngIf="dataSource.loading$ | async" class="w-100 mt-3 d-flex justify-content-center">
        <mat-progress-spinner [diameter]="48" color="primary" mode="indeterminate"></mat-progress-spinner>
    </div>
</div>
